import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { useQueryClient } from '@tanstack/react-query';

interface RefreshButtonProps {
  queryKeys?: string[][];
  onRefresh?: () => void;
}

export function RefreshButton({ queryKeys, onRefresh }: RefreshButtonProps) {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();

  const handleRefresh = async () => {
    setIsRefreshing(true);

    try {
      if (queryKeys && queryKeys.length > 0) {
        // Invalidate specific queries
        await Promise.all(
          queryKeys.map(key => queryClient.invalidateQueries({ queryKey: key }))
        );
      } else {
        // Invalidate all analytics queries
        await queryClient.invalidateQueries({ queryKey: ['analytics'] });
      }

      onRefresh?.();
    } catch (error) {
      console.error('Refresh failed:', error);
    } finally {
      // Add a small delay for UX
      setTimeout(() => setIsRefreshing(false), 500);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleRefresh}
      disabled={isRefreshing}
    >
      <RefreshCw className={`mr-2 h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
      {isRefreshing ? 'Refreshing...' : 'Refresh'}
    </Button>
  );
}
